// Compare by strings, can be used to sort Name, Description columns etc.
// Eg used in BankReconciliationSmart.js, BankReconciliationManual.js, ProductPriceLevel Table.js
export function sortColumnByString(strA, strB) {
    if (strA != null && strB != null)
        return strA.localeCompare(strB);
    if (strA) // strB is missing
        return 1;
    if (strB) // strA is missing
        return -1;
    return 0;
}
